module.exports = __webpack_public_path__ + "static/media/united-states.f5fdeeb9.svg";